const Emoji_OP = {
    ':ohmy': { id: 372, width: 20, height: 20 },
    ':ohplease': { id: 10, width: 20, height: 20 },
    ':omg': { id: 33, width: 18, height: 18 },
    ':online2long': { id: 373, width: 18, height: 18 },
    ':osama': { id: 374, width: 18, height: 25 },
    ':paperbag1': { id: 375, width: 20, height: 19 },
    ':paperbag3': { id: 376, width: 20, height: 19 },
    ':pardon': { id: 377, width: 36, height: 26 },
    ':partytime': { id: 378, width: 49, height: 31 },
    ':peace': { id: 379, width: 25, height: 21 },
    ':pepsi': { id: 56, width: 18, height: 18 },
    ':phone_1': { id: 380, width: 20, height: 18 },
    ':phone': { id: 381, width: 41, height: 28 },
    ':photo': { id: 382, width: 27, height: 21 },
    ':pig': { id: 383, width: 18, height: 21 },
    ':pilot': { id: 384, width: 35, height: 24 },
    ':pimp': { id: 385, width: 22, height: 25 },
    ':pinch': { id: 386, width: 18, height: 18 },
    ':pipe1': { id: 387, width: 32, height: 20 },
    ':pirate': { id: 40, width: 18, height: 18 },
    ':pirate2': { id: 388, width: 25, height: 25 },
    ':pissed': { id: 22, width: 20, height: 20 },
    ':plane': { id: 390, width: 47, height: 28 },
    ':play_ball': { id: 391, width: 46, height: 20 },
    ':pleasantry': { id: 392, width: 36, height: 26 },
    ':point': { id: 48, width: 18, height: 18 },
    ':police': { id: 393, width: 20, height: 22 },
    ':poo': { id: 601, width: 20, height: 19 },
    ':poop': { id: 61, width: 18, height: 18 },
    ':pop': { id: 55, width: 18, height: 18 },
    ':potty': { id: 394, width: 24, height: 26 },
    ':pray': { id: 395, width: 27, height: 22 },
    ':prayfor': { id: 607, width: 18, height: 18 },
    ':prop': { id: 396, width: 20, height: 25 },
    ':puke': { id: 397, width: 20, height: 25 },
    ':punch': { id: 398, width: 18, height: 18 },
    ':pussy': { id: 62, width: 18, height: 18 },
}

export default Emoji_OP
